<script setup lang="ts">
interface Props {
  path?: string
}

defineProps<Props>()
</script>

<template>
  <svg v-if="path" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" v-bind="$attrs">
    <path :d="path"></path>
  </svg>
</template>
